import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=6a0dd11a&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0dd11a",
  null
  
)

export default component.exports